import { BaseMessageLocales } from "@/locales/base.message.locales";
import * as ptBrLocales from "@/locales/pt-br/index";

export const ptBr: BaseMessageLocales = {
  new_about: { ...ptBrLocales.newAboutI18n },
  join_social_league: { ...ptBrLocales.join_social_league },
  covid_19: { ...ptBrLocales.covid_19 },
  buttons: { ...ptBrLocales.buttons },
  activities: { ...ptBrLocales.activities },
  footer: { ...ptBrLocales.footer },
  categories: { ...ptBrLocales.categories },
  challenge: { ...ptBrLocales.challenge },
  forum: { ...ptBrLocales.forum },
  files: { ...ptBrLocales.files },
  messages: { ...ptBrLocales.messages },
  home: { ...ptBrLocales.home },
  auth: { ...ptBrLocales.auth },
  navbar: { ...ptBrLocales.navbar },
  fields: { ...ptBrLocales.fields },
  contact: { ...ptBrLocales.contact },
  misc: { ...ptBrLocales.misc },
  team: { ...ptBrLocales.team },
  profile: { ...ptBrLocales.profile },
  skills: { ...ptBrLocales.skills },
  roles: { ...ptBrLocales.roles },
  timeline: { ...ptBrLocales.timeline },
  invites: { ...ptBrLocales.invites },
  tasks: { ...ptBrLocales.tasks },
  terms: { ...ptBrLocales.termsOfUse },
  privacy: { ...ptBrLocales.privacyPolicy },
  certificates: { ...ptBrLocales.certificates },
  notFounded: { ...ptBrLocales.notFounded },
  league: {
    title: "A LIGA",
    brazil: "Brasil"
  },
  faq: { ...ptBrLocales.faq },
  esic: { ...ptBrLocales.esic },
  Female: "Feminino",
  Male: "Masculino",
  Other: "Outro",
  "Afordable and clean energy": "Energia limpa e acessível",
  "Clean water and sanitation": "Água limpa e saneamento",
  "Climate action": "Ação Climática",
  "Decent work and economy growth": "Trabalho decente e crescimento da economia",
  "Gender equality": "Igualdade de gêneros",
  "Good health and well-being": "Boa saúde e bem-estar",
  "Industry, innovation and infrastructure": "Indústria, inovação e infraestrutura",
  "Life bellow water": "Vida embaixo d'água",
  "Life on land": "Vida em terra",
  "No poverty": "Sem pobreza",
  "Partnership for the goals": "Parceria para os objetivos",
  "Peace. Justice and strong institutions": "Paz. Justiça e instituições fortes",
  "Quality education": "Educação de Qualidade",
  "Reduced inequalities": "Desigualdades reduzidas",
  "Responsible consumption and production": "Consumo e produção responsáveis",
  "Sustainable cities and communities": "Cidades e comunidades sustentáveis",
  "Zero hunger": "Fome Zero"
};
